import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=188038f0"
import script from "./LoginAdmin.vue?vue&type=script&lang=ts"
export * from "./LoginAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports